import { devtools } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import { isDev } from 'Utilities/helpers';

const routerStore = () => ({
	prevQuery: null,
	prevRoute: null,
	prevRouteAsPath: null,
});

const useRouterStore = createWithEqualityFn(
	isDev
		? devtools(routerStore, {
				enabled: isDev,
				name: 'RouterStore',
			})
		: routerStore,
);

export default useRouterStore;
